import React from "react"
import defalutStyle from "../../styles/defaultPageStyle.module.css"
import { TitleChildrenPath } from "../Titles/Titles"
import { ButtonIcon } from "../Button/Button"
import { faClose } from "@fortawesome/free-solid-svg-icons"
import List, { type ListItem } from "../List/List"
import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import { SIZE } from "../../configuration/Sizes"
import THEME from "../../configuration/Theme"
import ModalPortal from "../Modal/ModalPortal"
import GetSpace from "../../utils/space"

export interface ListSelectionsProbs {
  title: string
  messageCount: string
  messageEmpty: string
  icon: IconProp
  listCards: ListItem[]
  iconColor?: string
  showFilterStatus?: boolean
  onClinck: (e: number) => void
  onClonse: () => void
}

const nameFindInputfild = "Buscar..."

export const ListSelections: React.FC<ListSelectionsProbs> = ({
  messageCount,
  messageEmpty,
  icon,
  onClinck,
  listCards,
  title,
  onClonse,
  showFilterStatus = false,
  iconColor,
}) => {
  return (
    <ModalPortal>
      <div className={defalutStyle.overlay}>
        <div className={defalutStyle.alert}>
          <TitleChildrenPath
            title={title}
            icon={icon}
            iconColor={iconColor || THEME.colors.iconBGSecondaryColor}
            subtitleChildren={
              <ButtonIcon
                sizeNumber={SIZE.buttonCloseIconSize}
                bgColor={THEME.colors.buttonBGCloseColor}
                iconColor={THEME.colors.buttonFGCloseColor}
                icon={faClose}
                onClick={onClonse}
                size="small"
                descriptionKey="interactionDescriptions:components.listSelections.listSelections.button.onClonse"
              />
            }
            children={
              <>
                <GetSpace top={10} />

                <List
                  showFilterStatus={showFilterStatus}
                  messageCount={messageCount}
                  messageEmpty={messageEmpty}
                  data={listCards}
                  nameFindSearch={nameFindInputfild}
                  handleOnClick={(e) => onClinck(e)}
                />
              </>
            }
          />
        </div>
      </div>
    </ModalPortal>
  )
}
